import React, { Component } from "react";
import brokerTitle from "../assets/brokerTitle.png";
import basketTitle from "../assets/basketTitle.png";
import profileTitle from "../assets/profileTitle.png";
import { Route, Redirect } from "react-router-dom";
import BasketsPage from "./BasketsContent";
import BrokersPage from "./BrokersContent";
import Profile from "./Profile";
import Loading from "../components/Loading";
import { ToastContainer } from "react-toastify";

export default class Steps extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobile: "",
      basketData: [],
      token: "",
      serverResponse: false,
      titleImage: null,
    };
  }

  componentDidMount() {
    document.body.style.backgroundColor = "white";
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
    };

    fetch("/api/checkToken", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.setState({ token: localStorage.getItem("token") });
          this.setState({ serverResponse: true });
        } else if (resultt.status === 401) {
          this.props.history.push("/Login");
        } else {
          alert("ارتباط با سرور برقرار نشد");
        }
      });
  }

  onBrokerLoad() {
    this.setState({ titleImage: brokerTitle });
  }

  onBasketLoad() {
    this.setState({ titleImage: basketTitle });
  }

  onProfileLoad() {
    this.setState({ titleImage: profileTitle });
  }

  onBrokerNext() {
    this.props.history.push(this.props.match.path + "/Baskets");
  }

  onBrokerBack() {
    localStorage.clear();
    this.props.history.push("/Login");
  }

  onBasketNext() {
    this.props.history.push(this.props.match.path + "/Profile");
  }

  onBasketBack() {
    this.props.history.goBack();
  }

  onProfileNext() {
    this.props.history.push("/");
  }

  onProfileBack() {
    this.props.history.goBack();
  }

  render() {
    if (this.state.serverResponse) {
      if (localStorage.getItem("token") === this.state.token) {
        return (
          <div className="basketPageStyle" id="main">
            <Route
              path={`${this.props.match.path}/Brokers`}
              render={(props) => (
                <BrokersPage
                  {...props}
                  showLogo={true}
                  onBrokerNext={this.onBrokerNext.bind(this)}
                  onBrokerBack={this.onBrokerBack.bind(this)}
                  onBrokerLoad={this.onBrokerLoad.bind(this)}
                />
              )}
            />
            <Route
              path={`${this.props.match.path}/Baskets`}
              render={(props) => (
                <BasketsPage
                  {...props}
                  showLogo={true}
                  onBasketNext={this.onBasketNext.bind(this)}
                  onBasketBack={this.onBasketBack.bind(this)}
                  onBasketLoad={this.onBasketLoad.bind(this)}
                />
              )}
            />
            <Route
              path={`${this.props.match.path}/Profile`}
              render={(props) => (
                <Profile
                  {...props}
                  inModal={false}
                  onProfileNext={this.onProfileNext.bind(this)}
                  onProfileBack={this.onProfileBack.bind(this)}
                  onProfileLoad={this.onProfileLoad.bind(this)}
                />
              )}
            />
            <ToastContainer />
          </div>
        );
      } else {
        return <Redirect to="/Login" />;
      }
    } else {
      return <Loading />;
    }
  }
}
